import { PartnerDetailPageState } from ".";
import { PtnrType } from "../../util/general-code/enums/general-codes";

const displayColumn = [
  { label: "Delete", value: "chnTypeDelFlg" },
  { label: "Chain Type", value: "chnTypeCd" },
  { label: "File Type", value: "fileTypeCd" },
];

export const PartnerDetailPageInitialState: PartnerDetailPageState = {
  /**
   * Partner Code List
   */
  searchResult: {
    ptnrInfo: {
      ptnrId: "",
      ptnrCd: "",
      ptnrName: "",
      ptnrNameWtngChng: "",
      ptnrTypeCd: PtnrType.OTHERS,
      ptnrTypeName: "",
      buCnTypeCd: "",
      buCnTypeName: "",
      buCd: "",
      cnCd: "",
      dipByRgn: "",
      cpntId: "",
      delFlg: "",
      updtDtimePtnr: "",
      chnTypeList: [],
    },
  },
  formValidation: {
    ptnrCd: true,
    manual: true,
    ptnrName: true,
    ptnrNameWtngChng: true,
    buCnTypeCd: true,
    buCd: true,
    cnCd: true,
    dipByRgn: true,
    cpntId: true,
  },
  manual: false,
  inboundSpreadsheetSelectedRowIndex: undefined,
  outboundSpreadsheetSelectedRowIndex: undefined,
  dataList: {
    fileTypeType: [],
    inboundEdiChainType: [],
    outboundEdiChainType: [],
    ptnrType: [],
    ptnrBuCntryType: [],
    cpntList: [],
    dipByRgn: [],
    deleteRowFlg: [
      { label: "Y", value: "Y" },
      { label: "N", value: "N" },
    ],
    inDefCommonFlagType: [],
  },
  fieldPath: {
    ptnrCd: "ptnrCd",
    ptnrName: "ptnrName",
    ptnrNameWtngChng: "ptnrNameWtngChng",
    buCnTypeCd: "buCnTypeCd",
    buCd: "buCd",
    cnCd: "cnCd",
    dipByRgn: "dipByRgn",
    cpntId: "cpntId",
  },
  displayColumn: displayColumn,
};
